// Password reset component
import { useContext, useEffect, useState } from 'react';
import { useForm, useFieldArray, SubmitHandler } from "react-hook-form";
import { useNavigate, Link, useParams } from 'react-router-dom';

import axios from 'axios';
import StateContext from '../stateContext';

function PasswordReset() {

  const { createNotification } = useContext(StateContext);
  const { loginParam, userid, passwordResetID } = useParams();
  const navigate = useNavigate();

  const {
    register,
    control,
    watch,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      new_password: "",
      new_password_confirmation: "",
      password_reset_id: passwordResetID,
      user_id: userid
    }
  });

  const password = watch("new_password");

  function requestPasswordReset(passwordResetData) {

    // encode password
    passwordResetData.password = btoa(unescape(encodeURIComponent(passwordResetData.password.trim())))
    passwordResetData.new_password_confirmation = btoa(unescape(encodeURIComponent(passwordResetData.new_password_confirmation.trim())))

    // make ajax call to reset password
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/account/passwordReset',
      passwordResetData
    ).then((response) => {
      if (response.status == 200 && response.data.success == true) {
        if (response.data.results > 0) {
          // reroute user to browse/home page with notification of email verification requirement
          navigate('/login/passwordResetSuccess');
        } else {
          // no results
          createNotification({
          "status": "error",
          "msg": "Password reset request error!",
        })
        }
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Password reset request error!",
        })
      }
    })

  }

  return (
    <form 
      onSubmit={handleSubmit(requestPasswordReset)}
      style={{
        height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
      }}
    >
      <section
        style={{minWidth: "300px", gap: "10px", display: "flex", flexDirection: "column"}}
      >
        <h1>Forgot Password</h1>
        <input 
          type="hidden"
          { ...register(`password_reset_id`, 
          { required: true })} 
          placeholder='Enter New Password'/>
        <input type="user_id"
          type="hidden"
          { ...register(`password_reset_id`, 
          { required: true })} 
          placeholder='Enter User ID'/>
        <input type="password"
          { ...register(`new_password`, 
          { required: true, minLength: { value: 3, message: "Experience title required!" } })} 
          placeholder='Enter New Password'
          style={ errors.new_password ? {border: "2px solid red"} : undefined}/>
        <input type="password"
          { ...register(`new_password_confirmation`, 
          { required: true, validate: (value) => value === password || "passwords do not match" })} 
          placeholder='Confirm New Password'
          style={ errors.new_password ? {border: "2px solid red"} : undefined}/>
        <button className="submit" type="submit">Reset Password</button>
      </section>
    </form>
  );
}

export default PasswordReset;